import { render, staticRenderFns } from "./ScheduledAnnouncementWidget.vue?vue&type=template&id=23a7f476&scoped=true&"
import script from "./ScheduledAnnouncementWidget.vue?vue&type=script&lang=js&"
export * from "./ScheduledAnnouncementWidget.vue?vue&type=script&lang=js&"
import style0 from "./ScheduledAnnouncementWidget.vue?vue&type=style&index=0&id=23a7f476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a7f476",
  null
  
)

export default component.exports